module.exports = __webpack_public_path__ + "static/media/Intersection 16.f6972999.png";